import script from "./nyTit1.vue?vue&type=script&setup=true&lang=js"
export * from "./nyTit1.vue?vue&type=script&setup=true&lang=js"

import "./nyTit1.vue?vue&type=style&index=0&id=e4985a1a&lang=less&scoped=true"
script.__scopeId = "data-v-e4985a1a"

export default script